/**
 * 資源／成本視圖共用的格式化工具（純函式，無 DOM／store 依賴）。
 */

/** 金額格式化，跟隨 project.currency。 */
export function formatMoney(amount: number, currency: string): string {
  try {
    return amount.toLocaleString('zh-TW', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    });
  } catch {
    // 未知幣別碼時退回純數字，避免 Intl 拋錯讓整個視圖崩潰。
    return `${currency} ${amount.toLocaleString('zh-TW', { maximumFractionDigits: 0 })}`;
  }
}

/** 金額格式化；null（例如缺少基準線）顯示為 em dash，不可誤判為 0。 */
export function formatMoneyOrDash(amount: number | null, currency: string): string {
  return amount === null ? '—' : formatMoney(amount, currency);
}

/** 工時（小時）格式化；0 顯示為空字串（與 MS Project 慣例一致）。顯示精度固定到小數點後一位。 */
export function formatHours(hours: number): string {
  if (hours === 0) return '';
  const rounded = Math.round(hours * 10) / 10;
  return `${Number.isInteger(rounded) ? rounded : rounded.toFixed(1)}h`;
}

/** 單位格式化（1 = 100%）。 */
export function formatUnits(units: number): string {
  return `${Math.round(units * 100)}%`;
}

/** 百分比格式化。 */
export function formatPercent(value: number): string {
  return `${Math.round(value)}%`;
}

/**
 * 比率格式化（SPI／CPI／TCPI）。分母為 0 時引擎回傳 `null`，
 * 必須顯示為「N/A」，不可誤判成 0 或顯示空白／null。
 */
export function formatRatio(value: number | null): string {
  return value === null ? 'N/A' : value.toFixed(2);
}
